import { Navigate, RouteObject } from 'react-router-dom';
import ForgotPassword from '../pages/dashboard/forgot-password';
import Login from '../pages/dashboard/login';
import ResetPassword from '../pages/dashboard/reset-password';
import { isAuthenticated } from '../utils/auth-utils';

export const authRoutes: RouteObject[] = [
  {
    path: '/dashboard/login',
    element: isAuthenticated() ? <Navigate to="/dashboard" /> : <Login />,
  },
  {
    path: '/dashboard/forgot-password',
    element: isAuthenticated() ? <Navigate to="/dashboard" /> : <ForgotPassword />,
  },
  {
    path: '/dashboard/password-reset',
    element: isAuthenticated() ? <Navigate to="/dashboard" /> : <ResetPassword />,
  },
];
